/* global espn */

/**
 * @fileOverview Utilty to setup Cricket specific fastcast connections.
 */

import actionTypes from '../../constants/actionTypes'
import * as transform from '../../lib/transform'
import { getPlayByPlayMore } from '../api/cricket'
import cloneDeep from 'lodash/cloneDeep'
import selectn from 'selectn'
//import qs from 'query-string'
//import moment from 'moment-timezone'

let scoreRef
let gamepackageRef


/**
 * Is this team specific scoreboard page?
 * @param  {Object}  params request params
 * @return {Boolean}        true if it's team specific scoreboard else false
 */
function isTeamBasedScoresPage(params) {
  if (params.pageType === 'scores') {
    if (params.hasOwnProperty('team') && typeof params.team === 'string') {
      //console.info('isTeamBasedScoresPage', true)
      return true
    }
  }
  return false
}

/**
 * Is this series specific scoreboard page?
 * @param  {Object}  params request params
 * @return {Boolean}        true if it's series specific scoreboard else false
 */
function isSeriesBasedScoresPage(params) {
  if (params.pageType === 'scores') {
    if (params.hasOwnProperty('league') && typeof params.league === 'string') {
      //console.info('isSeriesBasedScoresPage', true)
      return true
    }
  }
  return false
}


/**
 * Is fastcast available for this page?
 * @param  {Object} params request params
 * @return {Boolean}        true if fastcast should enable else false
 */
export function isFastCastAvailable(params) {
  //console.info('params', params)
  // Fastcast should be disabled if sport is not cricket
  if (params.hasOwnProperty('sport') && params.sport !== 'cricket') {
    return false
  }
  // Fastcast should be disabled if it's team/series specific scores page
  if (isTeamBasedScoresPage(params) || isSeriesBasedScoresPage(params)) {
    //console.info('On series/team sepcific scores page, fastcast will not update')
    return false
  }
  return true
}


/**
 * Should fastcast update be applied?
 * @param  {Object} query query object
 * @return {Boolean}       true if fastcast update should be applied else false
 */
/*
function shouldUpdateFastCast(query) {
  // Get current date in required format
  const curDate = moment.utc().format('YYYYMMDD')
  //console.info('curDate, query', curDate, query)
  if (query && query.hasOwnProperty('date')) {
    // Return false if current date is not same as date passed via query object
    if (query.date !== curDate) {
      //console.info('On different date than current one, fastcast will not update')
      return false
    }
  }
  return true
}
*/

export function disconnectScores() {
  const { fastCastMeta = {} } = this.props
  // Return if fastcast is not available
  if (fastCastMeta.enabled === false) {
    return
  }

  // Prepare for disconnect
  const { scoresTopic, topEventTopic } = fastCastMeta
  try {
    espn.flow.disconnect(scoresTopic, scoreRef)
    espn.flow.disconnect(topEventTopic, scoreRef)
    //console.info('After disconnecting cricket scores fastcast')
  }
  catch (e) {
    console.log('e', e)
  }
}


export function disconnectGPG() {
  const { fastCastMeta = {} } = this.props
  // Return if fastcast is not available
  if (fastCastMeta.enabled === false) {
    return
  }

  // Prepare for disconnect
  let topic = fastCastMeta.topic
  try {
    espn.flow.disconnect(topic, gamepackageRef)
    //console.info(`After disconnecting cricket ${topic} fastcast`)
  }
  catch (e) {
    console.log('e', e)
  }

}

/**
 * Handle messages received from scores fastcast connection
 * @param  {Object} res data received
 * @return {undefined}   undefined
 */
function handleScores(res = {}) {
  const { edition = {}, params = {}, location = {}, dispatch, fastCastMeta = {}, appProps = {}, isFastcastAllowed, topEvents = [] } = this.props
  //const query = location.query || qs.parse(location.search)
  if (fastCastMeta.enabled === true) {
    //console.info('handleScores: scores fastcast data received', res)
    //disabling ajax polling
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
    // set the flag that fastcast is allowed thru network
    if (isFastcastAllowed !== true) {
      dispatch({
        type: actionTypes.ALLOW_DENY_FASTCAST,
        payload: true
      })
    }

    if (res.topic == fastCastMeta.scoresTopic) {
      dispatch({
        params,
        edition,
        location,
        isFastcast: true,
        //url: gamepackage.url,
        type: actionTypes.GET_SCOREBOARD,
        data: transform.onGetScoreboard({ res, edition, params, location, appProps, topEvents })
      })
      console.log('FC : Update scoreboard')
    } else if (res.topic == fastCastMeta.topEventTopic) {
      dispatch({
        isFastcast: true,
        type: actionTypes.GET_TOPEVENTS,
        data: transform.onGetTopEventScores({ res, edition })
      })
      console.log('FC : Update topevents')
    }
  }
}

export function scoresFastCast() {
  const { fastCastMeta = {}, appProps = {}, edition = {} } = this.props
  /**
   * Do not setup fastcast connection if polling is not enabled.
   * See scoreboard.index.shouldPoll for the polling logic
   */
  if (fastCastMeta.enabled === false) {
    //console.info('Fastcast is not enabled')
    return
  }
  const { scoresTopic, topEventTopic } = fastCastMeta
  if (appProps.qaApi) {
    // reconnect the socket to perf.fastcast.go.com
    espn.flow.reconnect(null, { enablePerf: true })
  }
  // check topic is already subscribed to
  if (typeof scoreRef == 'undefined') {
    scoreRef = handleScores.bind(this)
  }
  if (typeof espn.flow.activeTopics[scoresTopic] == 'undefined') {
    espn.flow.connect(scoresTopic, scoreRef)
  } else if (typeof espn.flow.activeTopics[topEventTopic] == 'undefined'
    || (!edition.isEspnCricinfo && (selectn(`flow.activeTopics[${topEventTopic}].callbacks.length`, espn) || 0) <= 1)) {
    espn.flow.connect(topEventTopic, scoreRef)
  }
}

/**
 * Handle messages received from gamepackage fastcast connection
 * @param  {Object} res data received
 * @return {undefined}   undefined
 */
function handleGamepackage(res) {
  const resClone = cloneDeep(res)
  const { edition = {}, params = {}, dispatch, fastCastMeta = {}, appProps = {}, isFastcastAllowed, loading } = this.props
  const { pageType = '' } = params
  // Apply update if fastcast is enabled
  if (fastCastMeta.enabled === true) {
    //console.info('handleGamepackage: gamepkg fastcast data received', res)

    // disable ajax polling as fastcast is allowed
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }

    // set the flag that fastcast is allowed thru network
    if (isFastcastAllowed !== true) {
      dispatch({
        type: actionTypes.ALLOW_DENY_FASTCAST,
        payload: true
      })
    }

    dispatch({
      params,
      edition,
      location,
      appProps,
      isFastcast: true,
      //url: gamepackage.url,
      type: actionTypes.GET_GAMEPACKAGE,
      data: transform.onGetGamePackage({ res: resClone, edition, params, location, appProps })
    })
  }

  if (pageType == 'commentary' && !loading) {
    console.log('Commentary polling kicks in')
    dispatch(
      getPlayByPlayMore({ edition, params, location, page: null, isPolling: true, appProps })
    )
  }

  console.log('Update FC')
}

export function gamepackageFastCast() {
  const { fastCastMeta = {}, appProps = {} } = this.props
  /**
   * Do not setup fastcast connection if polling is not enabled.
   * See helpers.shouldPoll for the polling logic
   */
  if (fastCastMeta.enabled === false) {
    //console.info('Fastcast is not enabled, will NOT setup gamepackage fastcast')
    return
  }
  let topic = fastCastMeta.topic
  //console.info(`Setting up connection to ${topic}`, new Date())

  // Return since this topic is already subscribed to
  if (typeof espn.flow.activeTopics[topic] !== 'undefined') {
    //console.info('gamepackage fastcast is already setup', espn.flow.activeTopics[topic])
    return
  }

  gamepackageRef = handleGamepackage.bind(this)

  if (appProps.qaApi) {
    // reconnect the socket to perf.fastcast.go.com
    espn.flow.reconnect(null, { enablePerf: true })
  }
  espn.flow.connect(topic, gamepackageRef)

}



// WEBPACK FOOTER //
// ../app/actions/fastcast/cricket.js